/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { A11yModule } from "@angular/cdk/a11y";
import { ConfirmationDialogComponent } from "./confirmation-dialog.component";

@NgModule({
  declarations: [ConfirmationDialogComponent],
  imports: [CommonModule, FontAwesomeModule, A11yModule],
  exports: [ConfirmationDialogComponent]
})
export class ConfirmationDialogModule {}
